import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
// Copyright 1999-2019. Plesk International GmbH. All rights reserved.
import React, { Component, Fragment } from 'react';
import Button from '../Button';
import Translate from '../Translate';
import Progress from '../Progress';
import ProgressStep, { STATUS_DONE, STATUS_ERROR, STATUS_RUNNING, STATUS_NOT_STARTED } from '../ProgressStep';
import { CLS_PREFIX } from '../../constants';
import { safeInvoke } from '../utils';

var DrawerProgress =
/*#__PURE__*/
function (_Component) {
  _inherits(DrawerProgress, _Component);

  function DrawerProgress() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DrawerProgress);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DrawerProgress)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      status: null
    });

    _defineProperty(_assertThisInitialized(_this), "closeTimeout", void 0);

    _defineProperty(_assertThisInitialized(_this), "handleStatusChange", function (status) {
      var _this$props = _this.props,
          onClosableChange = _this$props.onClosableChange,
          onFinish = _this$props.onFinish,
          onFail = _this$props.onFail,
          cancelable = _this$props.cancelable,
          onStatusChange = _this$props.onStatusChange;
      var isNotStarted = status === STATUS_NOT_STARTED;
      var isFinished = status === STATUS_DONE;
      var isFailed = status === STATUS_ERROR;
      safeInvoke(onStatusChange, status);

      _this.setState({
        status: status
      });

      safeInvoke(onClosableChange, cancelable || isNotStarted || isFinished || isFailed);

      if (isFinished) {
        safeInvoke(onFinish);
      } else if (isFailed) {
        safeInvoke(onFail);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      var _this$props2 = _this.props,
          onClose = _this$props2.onClose,
          onCancel = _this$props2.onCancel,
          cancelable = _this$props2.cancelable;
      window.clearTimeout(_this.closeTimeout);

      if (cancelable) {
        safeInvoke(onCancel);
      }

      safeInvoke(onClose);
    });

    _defineProperty(_assertThisInitialized(_this), "handleCancel", function () {
      var _this$props3 = _this.props,
          onCancel = _this$props3.onCancel,
          onClose = _this$props3.onClose,
          cancelable = _this$props3.cancelable;
      window.clearTimeout(_this.closeTimeout);

      if (cancelable) {
        safeInvoke(onCancel);
      }

      safeInvoke(onClose);
    });

    return _this;
  }

  _createClass(DrawerProgress, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_prevProps, prevState) {
      var _this$props4 = this.props,
          autoCloseTimeout = _this$props4.autoCloseTimeout,
          onStart = _this$props4.onStart;
      var status = this.state.status;

      if (prevState.status !== STATUS_DONE && status === STATUS_DONE) {
        window.clearTimeout(this.closeTimeout);

        if (autoCloseTimeout) {
          this.closeTimeout = window.setTimeout(this.handleClose, autoCloseTimeout);
        }
      }

      if (prevState.status === STATUS_NOT_STARTED && status !== STATUS_NOT_STARTED) {
        safeInvoke(onStart);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.clearTimeout(this.closeTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          baseClassName = _this$props5.baseClassName,
          title = _this$props5.title,
          steps = _this$props5.steps,
          buttons = _this$props5.buttons,
          cancelable = _this$props5.cancelable;
      var status = this.state.status;
      var isFinished = status === STATUS_DONE;
      var isRunning = status === STATUS_RUNNING;
      var isFailed = status === STATUS_ERROR;
      var canCancel = (cancelable || !cancelable && !isRunning) && !(isFinished || isFailed);
      /* eslint-disable react/jsx-indent */

      return React.createElement(Fragment, null, title && React.createElement("div", {
        className: "".concat(baseClassName, "__title")
      }, title), React.createElement(Progress, {
        onStatusChange: this.handleStatusChange,
        className: "".concat(baseClassName, "__progress")
      }, steps.map(function (step, index) {
        return React.createElement(ProgressStep, _extends({
          key: index.toString()
        }, step));
      })), React.createElement("div", {
        className: "".concat(baseClassName, "__footer")
      }, buttons, (isFinished || isFailed) && React.createElement(Button, {
        onClick: this.handleClose
      }, React.createElement(Translate, {
        content: "DrawerProgress.closeButton",
        fallback: "Close"
      })), canCancel && React.createElement(Button, {
        onClick: this.handleCancel
      }, React.createElement(Translate, {
        content: "DrawerProgress.cancelButton",
        fallback: "Cancel"
      }))));
    }
  }]);

  return DrawerProgress;
}(Component);

_defineProperty(DrawerProgress, "defaultProps", {
  baseClassName: "".concat(CLS_PREFIX, "drawer-progress"),
  autoCloseTimeout: 3000,
  cancelable: false,
  steps: []
});

export default DrawerProgress;